export const WHATSAPP_NUMBER = "393349408506";
export const RESTAURANT_PHONE = "0775327702";
export const RESTAURANT_PHONE_TEL = "+390775327702";
export const RESTAURANT_PHONE_LABEL = "0775 327702";
